import FileLoaderService from './fileLoaderService';
import { DicomMetadataStore } from '@ohif/core';

const NON_DICOM_TYPES = ['application/pdf', 'text/plain'];

const processDicomFile = async file => {
  try {
    const fileLoaderService = new FileLoaderService(file);
    if (NON_DICOM_TYPES.includes(fileLoaderService.fileType)) {
      return null; // skip non-DICOM in first pass
    }

    const imageId = fileLoaderService.addFile(file);
    const image = await fileLoaderService.loadFile(file, imageId);
    const dicomJSONDataset = await fileLoaderService.getDataset(image, imageId);

    // Store reference to original File so extensions (e.g. download-manager) can access it
    dicomJSONDataset.localFile = file;

    DicomMetadataStore.addInstance(dicomJSONDataset);
    return dicomJSONDataset;
  } catch (error) {
    console.log(
      error.name,
      ':Error when trying to load and process local files:',
      error.message
    );
    return null;
  }
};

const processNonDicomFile = async (file, parentStudy) => {
  try {
    const fileLoaderService = new FileLoaderService(file);
    if (!NON_DICOM_TYPES.includes(fileLoaderService.fileType)) {
      return; // skip DICOM files in second pass
    }

    const imageId = fileLoaderService.addFile(file);
    const image = await fileLoaderService.loadFile(file, imageId);
    const dataset = fileLoaderService.getDataset(image, imageId);

    // Store reference to original File so extensions (e.g. download-manager) can access it
    dataset.localFile = file;
    dataset.SeriesDescription = file.name || dataset.SeriesDescription;

    // Attach to the parent DICOM study instead of creating a new one
    if (parentStudy) {
      dataset.StudyInstanceUID = parentStudy.StudyInstanceUID;
      dataset.PatientName = parentStudy.PatientName || '';
      dataset.PatientID = parentStudy.PatientID || '';
      dataset.StudyDate = parentStudy.StudyDate || '';
      dataset.StudyDescription = parentStudy.StudyDescription || '';
    }

    DicomMetadataStore.addInstance(dataset);
  } catch (error) {
    console.log(
      error.name,
      ':Error when trying to load and process local files:',
      error.message
    );
  }
};

export default async function filesToStudies(files) {
  // Pass 1: Process all DICOM files first to collect study info
  const dicomResults = await Promise.all(files.map(processDicomFile));
  const firstDicomDataset = dicomResults.find(d => d != null) || null;

  // Pass 2: Process non-DICOM files, attaching them to the first DICOM study
  await Promise.all(files.map(file => processNonDicomFile(file, firstDicomDataset)));

  return DicomMetadataStore.getStudyInstanceUIDs();
}
